// extracted by mini-css-extract-plugin
module.exports = {"root":"qpvSD0tB"};